import { createGlobalState } from '@vueuse/core'
import { useAuthState as useAuthStateVueAuth } from '@vueauth/core'
import { computed, ref, watch } from 'vue'
import stringSerializer from 'src/shared/serializers/stringSerializer'
import makeSqliteStorer from 'services/storage/local/makeSqliteStorer'
import { useRepo } from 'pinia-orm'
import { Org } from 'modules/Org/Org'
import { Tenant } from 'modules/Tenant/Tenant'

export const useAuthState = createGlobalState(() => {
  const authState = useAuthStateVueAuth()

  const tenantId = ref('')
  const orgId = ref('')

  const tenantIdRetrieved = ref(false)
  const orgIdRetrieved = ref(false)

  const tenantIdStorer = makeSqliteStorer('fuellox', 'tenantId', tenantId, stringSerializer, {
    onInitialGet (value) { tenantIdRetrieved.value = true },
  })
  const orgIdStorer = makeSqliteStorer('fuellox', 'orgId', orgId, stringSerializer, {
    onInitialGet (value) { orgIdRetrieved.value = true },
  })

  watch(orgId, (next) => {
    if (next === 'undefined') {
      orgId.value = ''
    }
  })

  watch(tenantId, () => {
    if (tenantId.value === 'undefined') {
      tenantId.value = ''
    }
  })

  const orgRepo = useRepo(Org)
  const tenantRepo = useRepo(Tenant)

  const org = computed(() => {
    return orgRepo.find(orgId.value)
  })
  const tenant = computed(() => {
    return tenantRepo.find(tenantId.value)
  })

  return {
    ...authState,
    tenantId,
    orgId,
    tenantIdRetrieved,
    orgIdRetrieved,
    tenantIdStorer,
    orgIdStorer,
    org,
    tenant,
  }
})
